import React from 'react';

function ManualTransactionFAB({ onClick }) {
    return (
        <button className="fab-btn" onClick={onClick} title="Add Transaction">
            +
        </button>
    );
}

export default ManualTransactionFAB;
